var request = new XMLHttpRequest();
request.open('HEAD', window.location.href, true);
request.send();

request.onreadystatechange = function() {
	if (this.readyState === 4) {
		// サーバーから時刻を取得
		var serverDate = new Date(request.getResponseHeader('Date'));

		// JSONからデータを取得し、画面に表示する
		$(window).on('load', function() {
			// ポイントアップキャンペーンのデータを取得
			var pointcpJson = '/material/json/pointcpList.json';
			fetch(pointcpJson)
				.then(response => response.json())
				.then(data => formatCpJSON(data, serverDate));
		});
	}
};

// JSONから取得したデータを整形し、画面に表示する
var formatCpJSON = function(json, serverDate) {
	// 表示するデータ
	var displayCpData = [];
	// データを抽出
	for (let i = 0; i < json.length; i++) {
		var cpBlock = json[i];
		var cpData = cpBlock.data;
		// 表示するデータを絞り込む
		for (let n = 0; n < cpData.length; n++) {
			var data = cpData[n];
			if (timeCheck(data.startDate, data.endDate, serverDate)) {
				displayCpData.push(data);
			};
		}
	}
	if (displayCpData.length > 0) {
		// 絞り込んだデータをhtml表記に整形
		var sliderListItemHTML = '';
		for (let l = 0; l < displayCpData.length; l++) {
			var sliderItemFrontHTML = '<li class=\"pointcp-slider__item ' + displayCpData[l].id + '\" id=\"' + displayCpData[l].id + '\"><div class=\"pointcp-store';
			var sliderItemBackHTML = '</div></div></li>';
			var itemHTML = '';
			if (displayCpData[l].logoPath) {
				itemHTML = '\"><div class=\"pointcp-store__logo\"><img src=\"' + displayCpData[l].logoPath + '\" alt=\"' + displayCpData[l].imgAltName + '\">';
			} else {
				itemHTML = ' text-item\"><div class=\"pointcp-store__text\"><span class=\"store-name\">' + displayCpData[l].storeName + '</span>';
			}
			sliderListItemHTML += (sliderItemFrontHTML + itemHTML + sliderItemBackHTML);
		}
		$('#pointcp-slider')[0].innerHTML = sliderListItemHTML;
	}
	pointcpLogoSlickInitialize();
};

// 開始日、終了日を基に、表示非表示を判定する
var timeCheck = function(startDate, endDate, serverDate) {
	// 各加盟店ごとに境界時間を取得
	var limitDateAStart = new Date(startDate);
	var limitDateAEnd = new Date(endDate);
	// 各境界時間までの秒数を宣言
	var rTimeAStart = (limitDateAStart - serverDate) / 1000;
	var rTimeAEnd = (limitDateAEnd - serverDate) / 1000;
	return rTimeAStart < 0 && !(rTimeAEnd < 0);
};